import React, {Component} from 'react';
import axios from 'axios';
import {withTranslation} from 'react-i18next';
import Qs from 'qs';
import _ from 'lodash';

import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import Container from '@material-ui/core/Container';
import DialogActions from '@material-ui/core/DialogActions';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';

import Conf from 'utils/Conf';

import 'index.css';
import './Newsletters.scss';

class Newsletters extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: {},
      user: {},
      news: [],
      newsInit: [],
    };
  }
  componentDidMount() {
    this.props.ed.addEventListener('userUpdate', this.userUpdate);
    this.userUpdate();
    axios.get(Conf.apiBaseUriLegacy + '/newsletters', {withCredentials: true}).then(res => {
      this.setState({news: res.data, newsInit: res.data});
    });
  }
  componentWillUnmount() {
    this.props.ed.removeEventListener('userUpdate', this.userUpdate);
  }

  userUpdate = () => {
    this.setState({user: _.cloneDeep(this.props.appState.user)});
  };

  setError = (name, value) => {
    const errors = this.state.errors;
    this.setState({
      errors: {
        ...errors,
        [name]: value,
      },
    });
  };
  handleFormSubmit = event => {
    event.preventDefault();
    const {user, news} = this.state;
    this.setState({
      errors: {},
    });
    let errors = 0;
    if (Object.keys(errors).length === 0) {
      axios
        .post(
          Conf.apiBaseUriLegacy + '/user/profile',
          Qs.stringify({
            ...user,
            _method: 'PATCH',
          }),
          {withCredentials: true},
        )
        .then(res => {
          const data = res.data;
          if (data.status === 'success') {
            this.props.methods.getProfile();
          } else if (data.status === 'error') {
            this.setError('patch', data.error);
          }
        });
      //NEWSLETTERS
      news.forEach(newsletter => {
        let formData = new FormData();
        formData.append('optin', newsletter.optin);
        axios.post(Conf.apiBaseUriLegacy + `/newsletter/${newsletter.id}`, formData, {
          withCredentials: true,
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
      });
      this.setState({newsInit: news});
    }
  };
  handleChange = event => {
    let {name, value, type} = event.target;
    const {user} = this.state;
    if (type === 'checkbox') {
      value = event.target.checked ? 1 : 0;
    }
    this.setState({
      user: {
        ...user,
        [name]: value,
      },
    });
  };
  handleChangeNewslettersCinema = event => {
    let {name, value, type} = event.target;
    if (type === 'checkbox') {
      value = event.target.checked ? 1 : 0;
    }
    let news = JSON.parse(JSON.stringify(this.state.news));
    let indexCurrentNews = news.findIndex(e => e.cinema_name === name);
    news[indexCurrentNews]['optin'] = value;
    this.setState({news: news});
  };

  renderCheckboxNewsletter = (newsletter, i) => {
    const {t} = this.props;
    return (
      <Grid key={i} container alignContent="center" alignItems="center">
        <Grid item xs={2} md={1}>
          <Checkbox
            color="default"
            checked={newsletter.optin === 1}
            onChange={this.handleChangeNewslettersCinema}
            name={newsletter.cinema_name}
            inputProps={{'aria-label': 'primary Checkbox'}}
          />
        </Grid>
        <Grid item xs={10} md={11}>
          {t(`newsletter-du-cinema`)} {` ` + newsletter.cinema_name}
        </Grid>
      </Grid>
    );
  };

  render() {
    const {t, appState} = this.props;
    const {user, news, newsInit} = this.state;
    return (
      user && (
        <Paper>
          <form onSubmit={this.handleFormSubmit} noValidate autoComplete="off">
            <Container disableGutters>
              <Grid container alignContent="center" alignItems="center">
                <Grid item xs={1} md={1}>
                  <Checkbox inputProps={{'aria-label': 'primary Checkbox'}} style={{visibility: 'hidden'}} />
                </Grid>
                <Grid item xs={11} md={11}>
                  {t(`je-souhaite-les-newsletters-de`)}
                </Grid>
                <Grid item xs={2} md={1}>
                  <Checkbox
                    color="default"
                    checked={user.newsletter === 1}
                    onChange={this.handleChange}
                    name="newsletter"
                    inputProps={{'aria-label': 'primary Checkbox'}}
                  />
                </Grid>
                <Grid item xs={10} md={11}>
                  De Cuult
                </Grid>
              </Grid>
              {news !== null &&
                news.length > 0 &&
                news.map((newsletter, i) => this.renderCheckboxNewsletter(newsletter, i))}
            </Container>
            <DialogActions>
              <Button
                type="submit"
                color="primary"
                variant="contained"
                disabled={_.isEqual(user, appState.user) && _.isEqual(news, newsInit)}
              >
                {t('mettre-a-jour')}
              </Button>
            </DialogActions>
          </form>
        </Paper>
      )
    );
  }
}
export default withTranslation()(Newsletters);
